<template>
  <div class="suggestion-clip-selider">
    <div v-if="clip_list.length > 0">
      <carousel
        :perPage="4"
        :perPageCustom="[
          [130, 1],
          [585, 2],
          [850, 3],
          [1190, 3],
        ]"
        :navigationEnabled="true"
        :scrollPerPage="false"
        :paginationEnabled="false"
        navigationNextLabel="<i class='fa fa-chevron-right'></i>"
        navigationPrevLabel="<i class='fa fa-chevron-left'></i>"
      >
        <slide v-for="clip in clip_list" :clip="clip" :key="clip.id">
          <div
            class="
              col-md-4 col-sm-4 col-xs-6
              no-padding no-margin
              featured-wraper
              add-clip
            "
            style="margin-bottom: 5px"
          >
            <div class="popluar-clip four-grid">
              <div class="popluar-clips-container">
                <div class="popluar-clip-header">
                  <small>{{
                    $options.filters.getChartaters(
                      clip.type_of_custom,
                      50,
                      "..."
                    )
                  }}</small>
                  <h3>
                    <a
                      :href="route('user.clip.show', { slug: clip.slug })"
                      target="_blank"
                      >{{ clip.title }}</a
                    >
                  </h3>
                </div>
                <div class="popular-clip-author">
                  <a
                    :href="userUrl(clip.user.slug)"
                    v-if="clip.user && clip.user.user_type === '0'"
                    >by {{ clip.user.first_name }}</a
                  >
                  <a :href="userUrl(clip.user.slug)" v-else-if="clip.user"
                    >by
                    {{ clip.user.first_name + " " + clip.user.last_name }}</a
                  >
                  <a href="#" v-else>by</a>
                </div>
                <div class="popluar-clip-content-wrapper">
                  <a
                    :href="route('user.clip.show', { slug: clip.slug })"
                    target="_blank"
                  >
                    <div
                      v-if="(clip.cliptype == 'image') & (clip.image !== '')"
                    >
                      <div class="popluar-clip-content has-img">
                        <hr />
                        <div class="image">
                          <div class="popluar-clip-image">
                            <img
                              v-bind:src="clip.default_clip_image"
                              :alt="clip.title"
                              class="clip-image"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="clip.cliptype == 'audio'"
                      v-html="clip.audio"
                    ></div>
                    <div
                      v-else-if="clip.cliptype == 'video'"
                      v-html="clip.video"
                    >
                      <!-- {{ clip.video }} -->
                    </div>
                    <div v-else>
                      <div class="popluar-clip-content has-text">
                        <hr />
                        <div
                          class="clip-content-data"
                          v-html="
                            $options.filters.getWords(clip.content, 81, '...')
                          "
                        ></div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div class="popluar-clip-footer">
                <hr />
                <div class="flex flex-justify-center">
                  <a
                    href="#"
                    class="suggestions_add_btn"
                    @click.prevent="AddClipToBook($event, clip.id)"
                  >
                    <i class="fa fa-plus" style="color: white"></i>
                    <span>Add to {{ trans("book.singular") }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
    <div v-else class="VueCarousel-error">
      <div v-if="errorMesg !== ''" class="clips-not-founded">
        {{ errorMesg }}
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  props: ["clip", "existClips", "sectionKey", "bookId"],
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      clip_list: [],
      selectedClips: [],
      existingClips: this.existClips ? this.existClips : null,
      errorMesg: "",
      // isSelected: 0;
    };
  },
  filters: {
    getWords: function (value, return_words, last_word = "") {
      if (!value) return "";

      if (value.length > return_words) {
        return value.split(/\s+/).slice(0, return_words).join(" ") + last_word;
      }
      return value;
    },
    coverImage(src) {
      var src_path = src.split("/");
      src_path.pop();
      src_path.push("conversions");
      src_path.push("cover.jpg");

      var result = src_path.join("/");
      return result;
    },
    getChartaters: function (value, return_characters, last_word = "") {
      if (!value) return "";
      value.replace("\n", "");
      if (value.length > return_characters) {
        return value.substr(0, return_characters) + last_word;
      }
      return value;
    },
  },
  beforeCreate() {},
  created() {
    var vm = this; //declare this just BEFORE calling axios();
    this.checkSavedClips();
    console.log("created");
  },
  methods: {
    slug(text) {
      return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w\-]+/g, "") // Remove all non-word chars
        .replace(/\-\-+/g, "");
    },
    checkSavedClips() {
      var app = this;
      var available_clips = 0;
      this.suggestedClips().then((res) => {
        available_clips = Object.keys(res.data).length;
      });
    },
    userUrl(slug) {
      return this.route("user.show", { slug: slug });
    },
    toggleSelect(id) {
      return this.selectedClips.includes(id)
        ? this.unSelect(id)
        : this.select(id);
    },
    select(id) {
      this.selectedClips.push(id);
      this.$emit("calculateSelectedClips", this.selectedClips);
    },
    unSelect(id) {
      //remove the id from the the list
      this.selectedClips = this.selectedClips.filter(function (clip) {
        return clip != id;
      });
      this.$emit("calculateSelectedClips", this.selectedClips);
    },
    unSelectAll() {
      //remove all the selected id from the the list
      this.selectedClips = [];
      this.$emit("calculateSelectedClips", this.selectedClips);
    },
    suggestedClips() {
      var req = this.route("book-suggested-clips", {});
      var query = {
        params: { section_id: this.sectionKey, book_id: this.bookId },
      };

      return this.axiosRequest(req, query);
    },
    searchClip(word, tab_name) {
      axios
        .post("/search-clip", {
          word: word,
          section_id: this.sectionKey,
          tab_name: tab_name,
        })
        .then((response) => {
          if (response.data.length > 0) {
            this.clip_list = response.data;
          } else {
            this.clip_list = [];
            this.errorMesg =
              "Sorry, there are no " +
              this.trans("clip.multiple") +
              " that match your search.";
          }
        });
    },
    isAddedClip(id) {
      var vm = this;
      let is_exist = "";

      if (vm.existingClips) {
        is_exist = this.existingClips.filter(function (clip) {
          // Check the clip is exist in the current section or not
          if (clip.id === id && vm.sectionKey == clip.pivot.section_id) {
            return true;
          }
        });
      }
      if (is_exist.length > 0) {
        return true;
      }
      return false;
    },
    axiosRequest(req, query) {
      var vm = this;
      return new Promise((resolve, reject) => {
        axios.get(req, query).then((response) => {
          if (Object.keys(response.data).length > 0) {
            this.clip_list = response.data;
          } else {
            this.clip_list = [];
            this.errorMesg =
              "Sorry, there are no " +
              vm.trans("clip.multiple") +
              " found in this section";
          }
          resolve(response);
        });
      });
    },
    AddClipToBook(event, clip_id) {
      event.target.parentElement.classList.add("hide"); // hide the add button when click on it
      let section_id = this.sectionKey;
      var data = {};
      data[`${section_id}`] = [clip_id];
      console.log(data);
      this.$store.commit("isLoading", true);
      axios
        .post(this.route("user.book.updateClipList", { id: this.bookId }), {
          clip_list: data,
          from_clip_slider: true,
        })
        .then(({ data }) => {
          this.$emit("completed", { result: data, section_id: section_id });
          this.$store.commit("isLoading", false);
          /* if (location.hash) {
						var currentUrl = window.location.pathname + '#'+section_name;
						window.location = currentUrl;
					} */
          this.notify(
            "success",
            `${this.trans("clip.Singular")} is added successfully.`
          );
        });
    },
  },
};
</script>

<style lang="scss">
.VueCarousel-navigation-next,
.VueCarousel-navigation-prev {
  color: #000 !important;
  display: inline-table;
  font-weight: bolder;
  font-size: 22px;
  padding-bottom: 175px !important;
  padding-top: 175px !important;
  top: 55% !important;
  margin-top: -20px;
}
.VueCarousel-navigation-prev .fa,
.VueCarousel-navigation-next .fa {
  margin-top: 0px;
  margin-left: 0px;
}
.clip-checkbox {
  display: none;
}
.VueCarousel-slide {
  max-width: 280px;
}
</style>